import { useCallback, useMemo } from "react";
import { useMarkers } from "../contexts/Markers";
import { useVideoPlayerRefs } from "../contexts/VideoPlayerRefs";
import { useVideoSource } from "../contexts/VideoSource";
import { getNextMarker, getPrevMarker } from "../utils/markers";

export const useStep = () => {
  const { duration } = useVideoSource();
  const { video } = useVideoPlayerRefs();
  const { markers } = useMarkers();

  const markersAreAvailable = markers.length > 0;

  const stepForwardBySeconds = useCallback(() => {
    if (video.current !== null) {
      video.current.currentTime = Math.min(
        duration,
        video.current.currentTime + 10
      );
    }
  }, [duration, video]);

  const stepBackwardBySeconds = useCallback(() => {
    if (video.current !== null) {
      video.current.currentTime = Math.max(0, video.current.currentTime - 10);
    }
  }, [video]);

  const stepToNextMarker = useCallback(() => {
    if (video.current !== null) {
      const element = video.current;
      const { time } = getNextMarker(element.currentTime, markers);
      element.currentTime = time;
    }
  }, [markers, video]);

  const stepToPrevMarker = useCallback(() => {
    if (video.current !== null) {
      const element = video.current;
      const { time } = getPrevMarker(element.currentTime, markers);
      element.currentTime = time;
    }
  }, [markers, video]);

  const stepForward = markersAreAvailable
    ? stepToNextMarker
    : stepForwardBySeconds;

  const stepBackward = markersAreAvailable
    ? stepToPrevMarker
    : stepBackwardBySeconds;

  return useMemo(
    () => ({
      stepForward,
      stepBackward,
    }),
    [stepBackward, stepForward]
  );
};
